import { TelemetryOptions } from "./TelemetryOptions";

export const getDefaultTelemetryOptions = (): TelemetryOptions => ({
    disabled: false
});
